import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";

const env = (typeof import.meta !== 'undefined' && import.meta.env) ? import.meta.env : {};

const firebaseConfig = {
  apiKey: env.VITE_FIREBASE_API_KEY || "AIzaSyB4CbZXlqgNxqdcI8rE5rsOu4AyGqgf4rY",
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN || "cricket-scorer-43a5c.firebaseapp.com",
  projectId: env.VITE_FIREBASE_PROJECT_ID || "cricket-scorer-43a5c",
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET || "cricket-scorer-43a5c.firebasestorage.app",
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID || "147152118751",
  appId: env.VITE_FIREBASE_APP_ID || "1:147152118751:web:2d53231ffe5ca761529a6a",
  measurementId: env.VITE_FIREBASE_MEASUREMENT_ID || "G-QZX7PEPCN1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);

// OFFLINE SMART SYNC: persistent local cache queues every Firestore write in
// IndexedDB while offline and auto-syncs when the network returns — even
// across app restarts. Ground par net na ho to bhi performance docs, lastXI
// and match backups kabhi lost nahi hote.
let _db;
try {
  _db = initializeFirestore(app, {
    localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
  });
} catch (_) {
  // Private-mode browsers without IndexedDB — fall back to in-memory cache.
  _db = getFirestore(app);
}
export const db = _db;

// Configure auth to use device language
auth.useDeviceLanguage();
